<template>
  <Transition
    enter-active-class="transition"
    leave-active-class="transition"
    enter-from-class="opacity-0 translate-y-2"
    leave-to-class="opacity-0 translate-y-2"
    mode="out-in">
    <PriorityPlusList v-if="subNavigationOpen">
      <li class="dropdown-item bg-surface-base px-4 py-2">
        <button class="flex w-full items-center text-left" @click="goBack">
          <UiIcon name="chevron-left" size="lg" />
          <span>{{ t("basic.back") }}</span>
        </button>
      </li>
      <li
        v-for="item in subNavigationItem?.children"
        :key="item.id"
        class="flex">
        <CvdNavigationRouterLink
          active-class="text-primary border-l-primary pointer-events-none cursor-default"
          :to="{
            name: 'cvdPage',
            params: { slug: [subNavigationItem?.slug || '', item.slug] },
          }"
          variant="dropdown"
          @click="handleNavigationLinkClick(item)">
          {{ t(item.labelKey) }}
        </CvdNavigationRouterLink>
      </li>
    </PriorityPlusList>
    <PriorityPlusList v-else>
      <li v-for="item in navigationItems" :key="item.id" class="flex">
        <CvdNavigationRouterLink
          v-if="!item.children"
          active-class="text-primary border-l-primary pointer-events-none cursor-default"
          :to="{
            name: 'cvdPage',
            params: { slug: [item.slug] },
          }"
          variant="dropdown"
          @click="handleNavigationLinkClick(item)">
          {{ t(item.labelKey) }}
        </CvdNavigationRouterLink>
        <button
          v-else
          :class="
            cn(
              'dropdown-item flex justify-between border-l-4 border-l-transparent text-left',
              {
                'border-l-primary text-primary': isActive(item),
              },
            )
          "
          @click="openSubNavigation(item)">
          <span>{{ t(item.labelKey) }}</span>
          <UiIcon name="chevron-right" size="lg" />
        </button>
      </li>
    </PriorityPlusList>
  </Transition>
</template>

<script setup lang="ts">
import UiIcon from "@dpa-id-components/dpa-shared-components/src/components/UiIcon/UiIcon.vue";
import { cn } from "@dpa-id-components/dpa-shared-components/src/utils/cn.ts";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

import CvdNavigationRouterLink from "@/components/Cvd/CvdNavigation/CvdNavigationRouterLink.vue";
import PriorityPlusList from "@/components/Cvd/PriorityPlus/PriorityPlusList.vue";
import { useTracking } from "@/composition/shared/useTracking.ts";
import type { TopLevelNavigationItem } from "@/types/Cvd.ts";

const route = useRoute();
const { t } = useI18n();

const emit = defineEmits<{
  selected: [];
}>();
const { navigationItems } = defineProps<{
  navigationItems: TopLevelNavigationItem[];
}>();

const subNavigationOpen = ref(false);
const subNavigationItem = ref<TopLevelNavigationItem>();
function openSubNavigation(item: TopLevelNavigationItem) {
  trackEvent(
    "categoryNavigation_click_textButton_navlinkPriorityPlus",
    item.slug,
  );
  if (item.children) {
    subNavigationItem.value = item;
    subNavigationOpen.value = true;
  }
}

function goBack() {
  subNavigationOpen.value = false;
}

function isActive(item: TopLevelNavigationItem) {
  return item.children?.some((child) => route.path.includes(child.slug));
}

const { trackEvent } = useTracking();
function handleNavigationLinkClick(item: TopLevelNavigationItem) {
  trackEvent(
    "categoryNavigation_click_textButton_navlinkPriorityPlus",
    item.slug,
  );
  emit("selected");
}
</script>
